import $ from 'jquery';

const popup = $('.LegalNote');

$(window).on('load', () => {
    popup.addClass('ready');
});

const showPopup = () => {
    popup.addClass('open');
};
const hidePopup = () => {
    popup.removeClass('open');
};

$('.LegalNote__inner').on('click', function (ev) {
    ev.preventDefault();
    ev.stopImmediatePropagation();
});

$('.LegalNote').on('click', hidePopup);

$('#open-legal-note').on('click', showPopup);

$('.LegalNote__continue, .LegalNote__close ').on('click', hidePopup);
